import React, { useMemo } from 'react';

/**
 * Componente que genera un <select> con valores únicos de una propiedad del array.
 * * @param {Array<Object>} data - El array de datos (simulando el JSON).
 * @param {string} propertyKey - La clave del objeto a usar para las opciones.
 * @returns {JSX.Element} Un <select> con opciones únicas.
 */
function UniqueSelect({ data, propertyKey, selectedValue, onValueChange }) {

    // 1. Lógica de Extracción y Eliminación de Duplicados
    // Usamos useMemo para asegurar que este cálculo solo se ejecute cuando 
    // cambien los 'data' o el 'propertyKey'.
    const uniqueOptions = useMemo(() => {
        if (!data || data.length === 0 || !propertyKey) {
            return [];
        }

        // a) Extraer todos los valores de la propiedad
        const allValues = data
            .map(item => item[propertyKey])
            .filter(value => value !== undefined && value !== null); // Limpieza de valores nulos/indefinidos

        // b) Usar Set para obtener solo los valores únicos
        // El operador `...` convierte el Set de nuevo a un Array.
        const uniqueArray = [...new Set(allValues)];

        return uniqueArray.sort(); // Opcional: ordenar alfabéticamente
    }, [data, propertyKey]);


    // 2. Manejo de Cambio (Opcional)
    const handleChange = (event) => {
        // Aquí puedes manejar la lógica cuando el usuario selecciona una opción
        const selectedValue = event.target.value;
        //console.log(`Opción seleccionada: ${selectedValue}`);
        // Si necesitas actualizar el estado del componente padre, 
        // pasarías una función 'onSelect' a las props.
        onValueChange(event); 
    };

    if (uniqueOptions.length === 0) {
        return <p>No hay opciones únicas disponibles para la clave '{propertyKey}'.</p>;
    }
    let propertyText = propertyKey;
    if(propertyText == "filter2"){ 
        //console.info('CAMBIO PROPERTY ');
        propertyText = "año de deceso";
    };

    if(propertyText == "centropenal"){ 
        //console.info('CAMBIO PROPERTY ');
        propertyText = "centro penal";
    };    

     if(propertyText == "SEXO"){ 
        //console.info('CAMBIO PROPERTY ');
        propertyText = "género";
    };  
    
    return (
        <div className="select-container">
{/*             <label htmlFor={`select-${propertyKey}`}>{propertyKey.toUpperCase()}: </label> */}
<label></label>
            <select id={`select-${propertyKey}`} name={propertyKey} value={selectedValue} onChange={handleChange} className="orderby select-box-border-style1 form-control">
                
                {/* Opción por defecto */}
                <option value="">-- {propertyText.toUpperCase()}--</option> 

                {/* Mapear las opciones únicas */}
                {uniqueOptions.map((option, index) => (
                    <option key={index} value={option}>
                        {option}
                    </option>
                ))}
            </select>
        </div>
    );
}

export default UniqueSelect;